<template>
  <div>
    <div
        v-if="detail_loader"
        style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;background-color:rgba(255,255,255,0.31)"
    >
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 sm8 md8 class="text-xs-left">
          <!-- <h2>Create Workspace</h2> -->
        </v-flex>
      </v-layout>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-card>
             <!-- <v-flex xs12 class="text-xs-right" mt-1>
              <v-menu offset-y>
                <v-btn
                  slot="activator"
                  color="rgb(248 71 6)"
                  class="white--text list_notification"
                  @click="backtonotification()"
                >
                  <v-icon color="#bbbbc6" class="white--text mr-2"
                    >arrow_back</v-icon
                  >
                  back
                </v-btn>
              </v-menu>
            </v-flex> -->
            <v-form
              id="create_notification"
              data-vv-scope="createNotification"
              @submit.prevent="updateNotification()"
            >
              <v-card-text>
                <v-layout row wrap style="margin-bottom: 20px;">
                  <v-flex xs12 md12 lg8>
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                      <label>Notification Type :</label>
                    </v-flex>
                    <v-autocomplete
                        label="Select"
                        name="type"
                        :items="notification_types"
                        v-model="notification_detail.notification.type"
                        return-object
                        item-text="name"
                        item-value="key"
                        selected solo flat
                        v-validate="'required'"
                        clearable
                    ></v-autocomplete>
                  </v-flex>


                  <v-flex xs12 md12 lg12 style="display: flex">
                    <v-flex xs12 md8 lg4>
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                      <label>Topic :</label>
                    </v-flex>
                    <v-autocomplete
                        label="Topic"
                        name="sent_to_topics"
                        :items="topics"
                        item-text='text'
                        item-value='value'
                         solo flat
                        v-model="notification_detail.notification.sent_to_topics"
                        clearable>
                    </v-autocomplete>
                  </v-flex>

                    <v-flex xs12 md8 lg4>
                      <label>City Name</label>
                      <v-autocomplete
                          :items="cityList"
                          name="City Name"
                          label="Select City"
                          v-model="notification_detail.notification.city_id"
                          item-text="name"
                          item-value="id"
                          v-validate="'required'"
                          solo flat
                      >
                      </v-autocomplete>
                    </v-flex>

                  </v-flex>

                  <v-flex xs12 md12 lg8 v-if="notification_detail.notification.sent_to_topics ==
                  'promotional_notifications'">
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                      <label>Event Name :<span class="red--text v-text-field__details v-messages theme--light"
                                               v-if="custom_errors.event_name">{{ custom_errors.event_name }}</span>
                      </label>
                    </v-flex>
                    <v-text-field
                        name="Event Name"
                        v-model="notification_detail.notification.event_name"
                        label="Event Name"
                        clearable solo flat
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md12 lg8 row>
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                    <label>Schedule At :</label>
                    </v-flex>
                    <v-flex xs12 md12 lg12 style="display: flex; flex-wrap: wrap; padding:0px !important">
                      <v-flex xs12 md6 lg6>
                          <v-menu
                              ref="menu"
                              v-model="menu"
                              :close-on-content-click="false"
                              :return-value.sync="date"
                              transition="scale-transition"
                              offset-y
                              min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                  v-model="notification_detail.scheduled_date"
                                  label="Select Date"
                                  readonly solo flat
                                  v-bind="attrs"
                                  v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="notification_detail.scheduled_date"
                                no-title
                                scrollable solo flat
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                  text
                                  color="primary"
                                  @click="notification_detail.scheduled_date = null"
                              >
                                Clear
                              </v-btn>
                              <v-btn
                                  text
                                  color="primary"
                                  @click="menu = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.menu.save(date)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                      </v-flex>

                      <v-flex xs12 md6 lg6>
                        <v-menu
                            ref="menu2"
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="time"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="notification_detail.scheduled_time"
                                label="Select Time"
                                readonly
                                v-bind="attrs"
                                v-on="on" solo flat
                            ></v-text-field>
                          </template>
                          <v-time-picker
                              v-if="menu2"
                              v-model="notification_detail.scheduled_time"
                              full-width
                              use-seconds solo flat
                              @click:minute:seconds="$refs.menu2.save(time)"
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="notification_detail.scheduled_time = null"
                            >
                              Clear
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="menu2 = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.menu2.save(time)"
                            >
                              OK
                            </v-btn>
                          </v-time-picker>
                        </v-menu>
                      </v-flex>
                    </v-flex>
                  </v-flex>

                  <v-flex xs12 md12 lg8 style="margin-left: 10px; padding-bottom: 23px !important;"
                          v-if="notification_detail.notification.sent_to_topics != 'promotional_notifications'">
                    <v-checkbox style="padding: 0px !important;"
                        v-model="notification_detail.notification.is_user_specific"
                        label="Add Custom users name into notification"></v-checkbox>
                    <span style="color: red;"
                          v-if="notification_detail.notification.is_user_specific == 1">
                      The placeholder {user_name} will automatically replaced with user names.
                    </span>
                  </v-flex>

                  <v-flex xs12 md12 lg8>
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                      <label>Title :<span class="red--text v-text-field__details v-messages theme--light" v-if="custom_errors.title">{{ custom_errors.title }}</span></label>
                    </v-flex>
                    <v-text-field
                        name="title"
                        id="title"
                        v-model="notification_detail.notification.title"
                        clearable solo flat
                    ></v-text-field>
                  </v-flex>


                  <v-flex xs12 md12 lg8>
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                      <label>Body :<span class="red--text v-text-field__details v-messages theme--light" v-if="custom_errors.body">{{ custom_errors.body }}</span></label>
                    </v-flex>
                    <v-textarea
                        name="body"
                        label="Body"
                        rows="2"
                        v-model="notification_detail.notification.body"
                        clearable solo flat
                    ></v-textarea>
                  </v-flex>


                  <v-flex xs12 md12 lg8>
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                      <label>External Link :</label>
                    </v-flex>
                    <v-text-field
                        name="link_url"
                        label="External Link"
                        v-model="notification_detail.notification.link_url"
                        clearable solo flat
                    >
                    </v-text-field>
                  </v-flex>


                  <v-flex xs12 md12 lg8>
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                      <label>Image :</label>
                    </v-flex>
                    <v-img style="width: 270px; height: 180px;"
                        :src="notification_detail.notification.image != null ?
                        storage_path()+notification_detail.notification.image : '/images/no_image.png'"
                    ></v-img>
                  </v-flex>

                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small type="submit" :loading="loader"
                       :disabled="(notification_detail.notification.sent_to_topics == 'promotional_notifications' &&
                       (notification_detail.notification.event_name == '' ||
                       notification_detail.notification.event_name == null))">update </v-btn>
                <v-btn flat small to="/notifications">Cancel</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
      <v-snackbar
        :color="snackBar.color"
        :top="snackBar.top"
        :bottom="snackBar.bottom"
        :left="snackBar.left"
        :right="snackBar.right"
        v-model="snackBar.show"
      >
        {{ snackBar.message }}
        <v-btn dark flat @click.native="snackBar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>



<script>
import moment from "moment";
import { VueEditor } from "vue2-editor";
import axios from 'axios'

export default {
  name: "Create",
  components: {
    VueEditor,
  },
  watch:{
    "notification_detail.notification.type":function(val){
      if(val.key == 'open_adgebra_ad' || val.key == 'open_adgebra_ad_ios' ||
          val.key == 'open_mgid_ad_ios' || val.key == 'open_mgid_ad'){
        if(true){
          if(val.key == 'open_adgebra_ad_ios' || val.key == 'open_mgid_ad_ios'){
            this.topics = {'text' : "Non-VIP IOS User Notifications", 'value':"non_vip_user_ios"};
          }else if(val.key == 'open_adgebra_ad' || val.key == 'open_mgid_ad'){
            this.topics = {'text' : "Non-VIP User Notifications", 'value':"non_vip_user"};
          }

          this.notification_detail.notification.title = null;
          this.notification_detail.notification.body = null;
          this.custom_errors.title = '';
          this.custom_errors.body = '';
          if(this.notification_detail.notification.title == null){
            this.custom_errors.title = '';
          }
        }
      }else{
        this.topics = [
          {'text':"All", 'value':"All"},
          {'text' : "Personalised Notifications", 'value':"personalised_notifications"},
          {'text' : "Promotional Notifications", 'value':"promotional_notifications"}];
        if(this.notification_detail.notification.title == null){
          this.custom_errors.title = 'Title is required.';
        }
        if(this.notification_detail.notification.body == null){
          this.custom_errors.body = 'Body is required.';
        }
      }
    },
    "notification_detail.notification.is_user_specific": function (val) {
      if(val == true){
        if(!this.notification_detail.notification.title.includes("{user_name}")){
          this.notification_detail.notification.title = this.notification_detail.notification.title + " " + "{user_name}"
        }
      }else if(val == false){
        if(this.notification_detail.notification.title != null){
          this.notification_detail.notification.title = this.notification_detail.notification.title.replace("{user_name}", "");
        }
      }
    },
    "notification_detail.notification.title": function (val){
      if(val == null){
        if(this.notification_detail.notification.type.key != 'open_adgebra_ad'
            || this.notification_detail.notification.type.key != 'open_adgebra_ad_ios' ||
            this.notification_detail.notification.type.key != 'open_mgid_ad'){
          this.custom_errors.title = 'Title is required.';
        }else{
          this.custom_errors.title = '';
        }
        this.notification_detail.is_user_specific = false;
      }else{
        this.custom_errors.title = '';
      }
    },
    "notification_detail.notification.body": function (val){
      if(val == null){
        this.custom_errors.body = '';
        if(this.notification_detail.notification.type.key != 'open_adgebra_ad' ||
            this.notification_detail.notification.type.key != 'open_adgebra_ad_ios' ||
            this.notification_detail.notification.type.key != 'open_mgid_ad'){
          this.custom_errors.body = 'Body is required.';
        }
      }else{
        this.custom_errors.body = '';
      }
    },
    "notification_detail.notification.event_name" : function(val){
      if(val == null || val == ''){
        if(this.notification_detail.notification.sent_to_topics == 'promotional_notifications'){
            this.custom_errors.event_name = 'Event name is required.';
        }else{
          this.custom_errors.event_name = '';
        }
      }else{
        this.custom_errors.event_name = '';
      }
    }
  },
  data: () => {
    return {
      // image:'',
      notification_detail: {},
      notification_ID: null,
      notification_types:[],
      types: ["Advertisement", "General"],
      topics: [
        {'text':"All", 'value':"All"},
        {'text' : "Personalised Notifications", 'value':"personalised_notifications"},
        {'text' : "Promotional Notifications", 'value':"promotional_notifications"}
      ],
      status: ["Draft", "Published"],
      submit_loader: false,
        menu: false,
        modal: false,
        time: null,
        date: null,
        menu2: false,
        modal2: false,
      snackBar: {
        show: false,
        color: "",
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false,
      },
      loader:false,
      detail_loader:false,
      custom_errors: {
        title: '',
        body: '',
        event_name: ''
      },
      cityList: []
    };
  },

  methods: {
    backtonotification:function(){
      this.$router.push({name:"Notifications"});
    },
    getNotificationDetail: function () {
      this.detail_loader = true;
      axios
        .get(
          `${process.env.VUE_APP_API_URL}/api/v1/notification-edit-list/` +
            this.$route.params.notification_id,
          { headers: this.$headers }
        )
        .then((response) => {
          if (response.data.status == 1) {
            this.detail_loader = false;
             // console.log(response.data.scheduled_datetime);return;
            this.notification_detail = response.data.notification;
            this.detail_loader = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
     getTypeList:function()
        {
        axios
            .get(`${process.env.VUE_APP_API_URL}/api/v1/notification-types`,{headers:this.$headers})
            .then(response => {
              if (response.data.status == 1)
              { 
                this.notification_types = response.data.types;
              }
             
            })
    },
    updateNotification: function () {
      this.loader=true;

      let new_notification = Object.assign({}, this.notification_detail);
      new_notification.title = this.notification_detail.notification.title;
      new_notification.type = this.notification_detail.notification.type.key;
      // console.log(this.notification_detail.type);
      // new_notification.status = this.notification_detail.notification.status;
      // new_notification.sent_to_topics  = this.notification_detail.sent_to_topics;
      new_notification.body = this.notification_detail.notification.body;
      new_notification.link_url = this.notification_detail.notification.link_url;
      new_notification.notification_id = this.notification_detail.notification.id;
      new_notification.schedule_date = this.notification_detail.scheduled_date;
      new_notification.schedule_time = this.notification_detail.scheduled_time;
      new_notification.is_user_specific = this.notification_detail.notification.is_user_specific;
      new_notification.event_name = this.notification_detail.notification.event_name;
      new_notification.city_id = this.notification_detail.notification.city_id;

      // console.log(this.notification_detail.scheduled_date);return;
      if (this.notification_detail.notification.sent_to_topics == undefined) {
        new_notification.sent_to_topics = "NULL";
      } else {
        new_notification.sent_to_topics = this.notification_detail.notification.sent_to_topics;
      }

      axios
        .post(
          `${process.env.VUE_APP_API_URL}/api/v1/notification-update`,
          new_notification,
          { headers: this.$headers }
        )
        .then((response) => {
          if (response.data.status == 1) {
            this.loader = false;
            this.$router.push({name: 'Notifications', params:{message: response.data.message}});

            this.$router.push({ name: "" });
            this.snackBar.message = response.data.message;
            this.submit_loader = false;
          } else {
            this.loader = false;
            this.snackBar.message = response.data.message;
            this.snackBar.show = true;
          }
        })
        .catch((error) => {
          this.loader = false;
          console.log(error);
        })
        .finally(() => {
          this.loader = false;
          // this.submit_loader = false;
        });
    },
    getCityList(){
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/get-city-list`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.cityList = response.data.data;
              this.cityList.push({'id' : 0, 'name':"ALL"})
            }
          });
    }
  },

  mounted() {
    this.getCityList();
    this.getNotificationDetail();
    this.getTypeList();
  },
  // beforeUpdate()
  // {
  //    this.updateNotification();
  // },
};
</script>
